import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';

@Component({
    selector: 'aa-panel-h1-a1-ma1-md1',
    templateUrl: './panel-h1-a1-ma1-md1.component.html',
    styleUrls: [
        '../panels.scss',
        './panel-h1-a1-ma1-md1.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PanelH1A1MA1MD1Component implements OnInit
{
    public chipsState: Observable<boolean>;

    constructor (
        private store: Store<IAuroraState>
    )
    {
    }

    ngOnInit (): void
    {
        this.chipsState = this.store.select(fromRootStore.getChipsStatus);
    }
}
